angular
  .module('components', [
    'components.directives',
    'components.inicial',
    'components.planodiretor'
  ])
  .constant('toastr', toastr)
  .constant('moment', moment)
  .constant('URL_REST', 'https://geocontrole.troupetecnologia.com.br/api/')
  // .constant('URL_REST', 'http://192.168.10.14/geocontrole/api/')
  .constant('URL_GEOSERVER', 'https://geoserver.troupetecnologia.com.br/geoserver/')
  // .constant('URL_GEOSERVER', 'http://geoserver.gpxsolucao.com.br:8080/geoserver/')
  .constant('URL_LOGOS', 'https://geocontrole.troupetecnologia.com.br/dados/clientes/logo/') // 300 x 180
  // .constant('URL_LOGOS', 'http://geocontrole.geopix.com.br/dados/clientes/logo/') // 300 x 180
  .constant('URL_GEOCONTROLE', 'https://geocontrole.troupetecnologia.com.br/')
  // .constant('URL_GEOCONTROLE', 'http://geocontrole.geopix.com.br/')
  .constant('URL_IPTUBR', 'http://deviptubr.gpxsolucao.com.br/');
